/**
 * The reset's last view. Focuses its Close button on arrival: the form the user was typing in has
 * just been replaced, and focus must not be left on a node that no longer exists.
 *
 * @module @puffin-core/login-shell/components/passwordReset/ResetSuccess
 */

import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

/**
 * @param {Object} props
 * @param {Function} props.onClose
 * @param {Function} props.translate
 * @returns {React.JSX.Element}
 */
export function ResetSuccess({ onClose, translate }) {
  const closeRef = useRef(null);
  useEffect(() => {
    closeRef.current.focus();
  }, []);
  return (
    <div data-testid="reset-success">
      <p className="text text-sm text-center" role="status">
        {translate('modal.passwordReset.passwordChangedBody')}
      </p>
      <button
        ref={closeRef}
        type="button"
        className="btn btn-primary btn-lg w-full"
        onClick={onClose}
      >
        {translate('modal.passwordReset.close')}
      </button>
    </div>
  );
}

ResetSuccess.propTypes = {
  onClose: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
};

export default ResetSuccess;
